import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IPursesFeature } from './purses.feature.state';
import { PursesState } from './purses.state';

export const getPursesState: MemoizedSelector<IPursesFeature, PursesState> = createFeatureSelector<PursesState>(
  nameof<IPursesFeature>('PursesFeature')
);

export const getIsLoading = createSelector(getPursesState, (state: PursesState) => state.isLoading);

export const getFailures = createSelector(getPursesState, (state: PursesState) => state.failures);

export const getPurses = createSelector(getPursesState, (state: PursesState) => state.purses);
export const getTopUpOptionResponse = createSelector(getPursesState, (state: PursesState) => state.purseTopupOption);
export const getCashlessResponse = createSelector(getPursesState, (state: PursesState) => state.cashlessResponse);
export const getSelectedPurseID = createSelector(getPursesState, (state: PursesState) => state.selectedPurseID);
